import { fieldMappingService } from '../../../config/fieldMapping';
import type { SummaryCardFieldMapping, SummaryCardRow } from '../../../summary/summaryCardSourceTypes';
import type { RequestFieldDefinition, RequestFieldSummaryRow } from '../types';

export function resolveRbacKeysForDataField(
  dataField: string,
): { permissionSection: string; permissionField: string } | null {
  const mapping = fieldMappingService.getMappingByFormField(dataField);
  if (!mapping) {
    return null;
  }
  return {
    permissionSection: mapping.jsonSection,
    permissionField: mapping.jsonField,
  };
}

export function buildSummaryRowsFromFields(
  fields: readonly RequestFieldDefinition[],
): RequestFieldSummaryRow[] {
  const summaryFields = fields.filter((f) => f.surfaces.summary);
  const seenSubsections = new Set<string>();
  return summaryFields.map((field) => {
    const subsection = seenSubsections.has(field.subsectionId)
      ? undefined
      : field.subsectionId;
    seenSubsections.add(field.subsectionId);
    return {
      dataField: field.dataField,
      label: field.label,
      subsection,
      // Carried through to render time — the row is BUILT unconditionally so the
      // subsection heading (which rides on the first row) and testID order stay
      // stable; only the render skips. See isSummaryRowGateSatisfied.
      visibleWhenFieldContains: field.summaryVisibleWhenFieldContains,
    };
  });
}

/** Attach RBAC keys from `fieldMapping.ts` — not stored on registry rows. */
export function enrichSummaryRowsWithRbac(
  rows: readonly RequestFieldSummaryRow[],
): SummaryCardRow[] {
  return rows.map((row) => {
    const rbac = resolveRbacKeysForDataField(row.dataField);
    if (!rbac) {
      throw new Error(`No fieldMapping entry for summary dataField=${row.dataField}`);
    }
    return {
      ...row,
      permissionSection: rbac.permissionSection,
      permissionField: rbac.permissionField,
    };
  });
}

export function buildSummaryFieldMappingsFromRows(
  rows: readonly SummaryCardRow[],
): SummaryCardFieldMapping[] {
  return rows.map(({ dataField, permissionSection, permissionField }) => ({
    dataField,
    permissionSection,
    permissionField,
  }));
}
